// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"40991f67","680":"102fdea0"}[chunkId] + ".chunk.js";
};